module.exports = __webpack_public_path__ + "img/TopBannerNl.27c47608.png";